module.exports = __webpack_public_path__ + "img/User Pro.8cd639d1.svg";